import { lazy, Suspense } from 'react';
// import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';

import Home from './Home';
import TemplateWrapper from '../TemplateWrapper';
import {
  HOME_ROUTE,
  LOGIN_ROUTE,
  MOVIE_DETAILS_ROUTE,
  NOT_FOUND_ROUTE,
  SEARCH_MOVIE_ROUTE,
  POPULAR_MOVIES_ROUTE,
  TOP_RATED_MOVIES_ROUTE,
  UPCOMING_MOVIES_ROUTE,
} from '../../utils/constants';
import NotFound from './NotFound';
import PageLoader from '../utils/PageLoader';

const Login = lazy(() => import('./Login'));
const SearchMovie = lazy(() => import('./SearchMovie'));
const MovieDetails = lazy(() => import('./MovieDetails'));
const PopularMovies = lazy(() => import('./PopularMovies'));
const TopRatedMovies = lazy(() => import('./TopRatedMovies'));
const UpcomingMovies = lazy(() => import('./UpcomingMovies'));

const Body = () => {
  return (
    <Routes>
      <Route
        path={HOME_ROUTE}
        element={
          <TemplateWrapper routeUrl={HOME_ROUTE}>
            <Home />
          </TemplateWrapper>
        }
      />
      <Route
        path={SEARCH_MOVIE_ROUTE}
        element={
          <Suspense fallback={<PageLoader />}>
            <TemplateWrapper routeUrl={SEARCH_MOVIE_ROUTE}>
              <SearchMovie />
            </TemplateWrapper>
          </Suspense>
        }
      />
      <Route
        path={POPULAR_MOVIES_ROUTE}
        element={
          <Suspense fallback={<PageLoader />}>
            <TemplateWrapper routeUrl={POPULAR_MOVIES_ROUTE}>
              <PopularMovies />
            </TemplateWrapper>
          </Suspense>
        }
      />
      <Route
        path={TOP_RATED_MOVIES_ROUTE}
        element={
          <Suspense fallback={<PageLoader />}>
            <TemplateWrapper routeUrl={TOP_RATED_MOVIES_ROUTE}>
              <TopRatedMovies />
            </TemplateWrapper>
          </Suspense>
        }
      />
      <Route
        path={UPCOMING_MOVIES_ROUTE}
        element={
          <Suspense fallback={<PageLoader />}>
            <TemplateWrapper routeUrl={UPCOMING_MOVIES_ROUTE}>
              <UpcomingMovies />
            </TemplateWrapper>
          </Suspense>
        }
      />
      <Route
        path={`${MOVIE_DETAILS_ROUTE}:id`}
        element={
          <Suspense fallback={<PageLoader />}>
            <TemplateWrapper routeUrl={MOVIE_DETAILS_ROUTE}>
              <MovieDetails />
            </TemplateWrapper>
          </Suspense>
        }
      />
      <Route
        path={LOGIN_ROUTE}
        element={
          <Suspense fallback={<PageLoader />}>
            <TemplateWrapper routeUrl={LOGIN_ROUTE}>
              <Login />
            </TemplateWrapper>
          </Suspense>
        }
      />
      <Route
        path={NOT_FOUND_ROUTE}
        element={
          <TemplateWrapper routeUrl={NOT_FOUND_ROUTE}>
            <NotFound />
          </TemplateWrapper>
        }
      />
    </Routes>
  );
};

export default Body;
